/* @flow */
import * as React from 'react';
import { SearchModalContext, type SearchModalContextType } from '../context/SearchModalContext';

function useSearchModalContext(): SearchModalContextType {
  return React.useContext(SearchModalContext);
}

export default useSearchModalContext;
